const DEFAULT_BREADCRUMBS = [
  {
    labelText: 'Anasayfa',
    url: '/',
    isRoot: true
  }
];

const MAX_QUICK_FILTER_VIEW_COUNT = 5;

const DEFAULT_LISTING_BANNER_SETTINGS = {
  autoRotate: true,
  showArrowsOnlyOnHover: true,
  shouldLoadEagerly: true
};

const DESKTOP_LISTING_BANNER_SETTINGS = {
  ...DEFAULT_LISTING_BANNER_SETTINGS
};

const MOBILE_LISTING_BANNER_SETTINGS = {
  ...DEFAULT_LISTING_BANNER_SETTINGS,
  sliderDots: false
};

const LANDING_PAGES_CATEGORIES = ['2147483636'];

const SPORT_AND_OUTDOOR_FOOTER_VIEW_NAME = 'sportAndOutdoorFooter'
const COMPUTER_FOOTER_VIEW_NAME = 'computerFooter'
const FASHION_FOOTER_VIEW_NAME = 'fashionFooter'
const SUPERMARKET_FOOTER_VIEW_NAME = 'supermarketFooter'
const PHONE_FOOTER_VIEW_NAME = 'phoneFooter'
const HOME_ELECTRONICS_FOOTER_VIEW_NAME = 'homeElectronicsFooter'

export {
  LANDING_PAGES_CATEGORIES,
  DEFAULT_BREADCRUMBS,
  MAX_QUICK_FILTER_VIEW_COUNT,
  DESKTOP_LISTING_BANNER_SETTINGS,
  MOBILE_LISTING_BANNER_SETTINGS,
  COMPUTER_FOOTER_VIEW_NAME,
  SPORT_AND_OUTDOOR_FOOTER_VIEW_NAME,
  FASHION_FOOTER_VIEW_NAME,
  SUPERMARKET_FOOTER_VIEW_NAME,
  PHONE_FOOTER_VIEW_NAME,
  HOME_ELECTRONICS_FOOTER_VIEW_NAME
};
